import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class CryptoService {
  private cryptoKey = '4aEyZMocyH5UqIzrNhgkqtJewwZE3aHH';
  constructor() {
  }

  set(value) {
    const key = CryptoJS.enc.Utf8.parse(this.cryptoKey);
    const iv = CryptoJS.enc.Utf8.parse(this.cryptoKey);
    const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(value.toString()), key,
      {
        keySize: 128 / 8,
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });

    return encrypted.toString();
  }

  get(value) {
    if (value) {
    const key = CryptoJS.enc.Utf8.parse(this.cryptoKey);
    const iv = CryptoJS.enc.Utf8.parse(this.cryptoKey);
    const decrypted = CryptoJS.AES.decrypt(value, key, {
      keySize: 128 / 8,
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
  }
  }
}
